import React from 'react';
import { connect } from 'react-redux';
import {
  FormGroup,
  ListGroup,
  ListGroupItem,
  Button,
} from 'react-bootstrap';

import IPFSLink from './IPFSLink';

import {
  reindexAuctions,
  reindexLiveAuctions,
} from '../util/thunks';

class ReindexForm extends React.Component {
  render() {
    return (
      <form>
        <FormGroup controlId="tokenURI">
          <Button onClick={this.props.reindexAuctions}>Reindex Auctions</Button>
          <Button onClick={this.props.reindexLiveAuctions}>Reindex Live Auctions</Button>
        </FormGroup>

        <ListGroup>
          {this.props.data.error &&
            <ListGroupItem bsStyle="danger">{this.props.data.error}</ListGroupItem>
          }
          {this.props.data.success &&
            <ListGroupItem bsStyle="success">Reindexed to IPFS! <IPFSLink hash={this.props.data.hash} /></ListGroupItem>
          }
        </ListGroup>
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.reindexForm,
  };
};

const mapDispatchToProps = (dispatch) => ({
  reindexAuctions: () => {
    return dispatch(reindexAuctions());
  },
  reindexLiveAuctions: () => {
    return dispatch(reindexLiveAuctions());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ReindexForm);



// WEBPACK FOOTER //
// ./src/components/ReindexForm.js